import { render, staticRenderFns } from "./AffiliateSales.vue?vue&type=template&id=38a8751a&scoped=true&"
import script from "./AffiliateSales.vue?vue&type=script&lang=ts&"
export * from "./AffiliateSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8751a",
  null
  
)

export default component.exports